import { Transportation } from "../../../../../lib/runescape/transportation";
import { Transform, Vector2 } from "../../../../../lib/math";
import { TileTransform } from "../../../../../lib/runescape/coordinates/TileTransform";
import { TileCoordinates, TileRectangle } from "../../../../../lib/runescape/coordinates";
export class EntityActionBuilder {
    constructor(value) {
        this.value = value;
    }
    movement(...movement) {
        this.value.movement.push(...movement.map(m => m.done()));
        return this;
    }
}
export class EntityTransportationBuilder {
    constructor(underlying, value) {
        this.underlying = underlying;
        this.value = value;
    }
    finish() {
        let transport = this.value;
        transport.source_loc = this.underlying.prototype.id;
        let use = this.underlying;
        // Apply rotation
        if (use.instance.rotation != 0) {
            transport = Transportation.transform(transport, TileTransform.normalize(Transform.rotation((4 - use.instance.rotation) % 4)));
        }
        const current_origin = transport.type == "entity"
            ? TileRectangle.bl(transport.clickable_area)
            : transport.position;
        transport = Transportation.transform(transport, TileTransform.translation(Vector2.sub(use.box.origin, current_origin), use.box.origin.level));
        if (transport.type == "entity") {
            transport.clickable_area = TileRectangle.extend(transport.clickable_area, 0.5);
        }
        return this.value = transport;
    }
}
export class GeneralEntityTransportationBuilder extends EntityTransportationBuilder {
    constructor(underlying, value) {
        super(underlying, value);
        this.underlying = underlying;
        this.value = value;
    }
    action(override = {}, ...movements) {
        const action = this.underlying.prototype.actions[override.index ?? 0];
        const a = new EntityActionBuilder({
            name: override.name ?? action?.[0] ?? "Unnamed Action",
            cursor: override.cursor ?? action?.[1] ?? "generic",
            interactive_area: override.interactive_area ?? undefined,
            movement: [],
        });
        if (a.value.name == "Unnamed Action")
            debugger;
        a.movement(...movements);
        this.value.actions.push(a.value);
        return this;
    }
}
(function (EntityTransportationBuilder) {
    function from(instance) {
        const transport = {
            type: "entity",
            entity: { name: instance.prototype.name, kind: "static" },
            clickable_area: TileRectangle.from({ x: 0, y: 0, level: 0 }, TileCoordinates.lift(Vector2.add(instance.prototype.size, { x: -1, y: -1 }), 0)),
            actions: [],
        };
        return new GeneralEntityTransportationBuilder(instance, transport);
    }
    EntityTransportationBuilder.from = from;
})(EntityTransportationBuilder || (EntityTransportationBuilder = {}));
